import {
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Switch
  } from '@chakra-ui/react';
  import { ReactNode } from 'react';
  import { Control, Controller, UseFormReturn } from 'react-hook-form';
  
  type Props = {
    form: UseFormReturn<any, any, undefined>;
    name: string;
    label: string | ReactNode;
    extra?: ReactNode;
    hideInput?: boolean;
    placeholder?: string
  };
  
  const CheckBoxField = ({ form, label, name, extra, hideInput, placeholder }: Props) => {
    return (
      <Controller
            name={name}
        control={form.control}
        render={({ field, fieldState }) => (
            <div>
            <FormControl
              paddingBottom={0}
              isInvalid={fieldState.error?.message ? true : false}
            >
              <Flex justifyContent={'space-between'} alignItems={"center"} >
                <FormLabel
                  marginBottom={0}
                  fontWeight={600}
                  textTransform={'capitalize'}
                  htmlFor="name"
                >
                  {label}
                </FormLabel>
                <Switch
                    colorScheme='#f00'
                    onChange={field.onChange}
                    isChecked={field.value}
                  />
              </Flex>
             
              {fieldState.error && (
                <FormErrorMessage>
                  {fieldState.error?.message && fieldState.error?.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </div>
        )}
      />
    );
  };
  
  export default CheckBoxField;
  